import { ChatTranslation } from 'locales/de/pages/chat';

const en: ChatTranslation = {
  title: 'gKI-Chat',
  copyCode: 'Copy code',
  placeholder: 'Please enter your message...',
  error: 'An error occurred',
  apiKeyManagement: 'API-Key Management',
  topWarning:
    'Please note: This is a test system that is only accessible to selected users. Please report errors and problems to the data centre support or to support@artcodix.com.',
  warning: 'THRO gKI-Chat can make mistakes. Consider checking important information.',
  possibilities: 'Possibilities',
  limitations: 'Limitations',
  newChat: 'New Chat',
  infoBoxes: {
    contextUnderstanding: {
      title: 'Context understanding',
      text: 'Understands what was said previously.'
    },
    iteration: {
      title: 'Iteration',
      text: 'Allows for iterative corrections of generated results.'
    },
    formatting: {
      title: 'Formatting',
      text: 'Generates results in a more readable form.'
    },
    dataPrivacy: {
      title: 'Data privacy',
      text: 'This is a language model operated in Rosenheim. Your data will not leave Rosenheim and your enquiries will not be stored.'
    },
    incomplete: {
      title: 'Incomplete',
      text: 'Sometimes generates incorrect or incomplete information.'
    },
    attention: {
      title: 'Attention',
      text: 'Sometimes generates inappropriate or misleading information.'
    },
    limitation: {
      title: 'Limitation',
      text: 'The language model only accesses knowledge up to december of 2024.'
    },
    multiModelSupport: {
      title: 'Multi-Model Support',
      text: 'Choose from various open-weight models for your queries.'
    },

    knowledgeLimits: {
      title: 'Knowledge Limits',
      text: 'Open-weight models have a knowledge cutoff at the time of training and are unaware of events occurring after that point.'
    },

    chatHistory: {
      title: 'Chat History',
      text: 'Your conversations are saved and can be resumed or searched at any time.'
    },

    hallucinations: {
      title: 'Hallucinations',
      text: 'The models may occasionally present false or fabricated information as factual.'
    },

    fileUpload: {
      title: 'File Upload',
      text: 'Upload documents, images, and other files to analyze them with the AI.'
    },

    performance: {
      title: 'Computational Performance',
      text: 'Complex queries may take longer to process due to limited local resources compared to cloud-based services.'
    },

    pluginsAndTools: {
      title: 'Plugins & Tools',
      text: 'Use integrated tools for web search, code execution, and additional functionalities.'
    },

    languageQuality: {
      title: 'Language Quality',
      text: 'Open-weight models are primarily trained on English—German responses may be less precise.'
    },

    privacy: {
      title: 'Privacy',
      text: 'Self-hosted solution — your data remains on our servers in Rosenheim and is never shared with third parties.'
    }
  },
  rooms: {
    chat: 'Chat',
    finance: 'Finance',
    research: 'Research',
    marketing: 'Marketing',
    programming: 'Programming',
    legal: 'Legal Advice',
    social: 'Social Media'
  },
  partners: {
    finance: {
      name: 'Finn Anz',
      text: 'You are now talking to your fictitious financial advisor. What would you like to know about finance?'
    },
    research: {
      name: 'Forsch Unger',
      text: 'You are now talking to your fictitious financial advisor. What would you like to know about finance?'
    },
    marketing: {
      name: 'Mark Eting',
      text: 'You are now talking to a fictitious marketing consultant. What would you like to know about marketing?'
    },
    programming: {
      name: 'Paul Python',
      text: 'You are now talking to a fictitious programmer. What would you like to know about programming?'
    },
    legal: {
      name: 'Richard Recht',
      text: 'You are now talking to a fictitious legal adviser. What would you like to know about rights?'
    },
    social: {
      name: 'Susi Sozial',
      text: 'You are now talking to a fictitious social media manager. What would you like to know about social media?'
    }
  },
  dialogs: {
    deleteChat: {
      title: 'Delete Chat',
      message: 'Are you sure you want to delete this chat?'
    }
  },
  feedbackButton: 'Give feedback',
  chatPortalButton: 'Visit Chat',
  tooltips: {
    oneAttachmentOnly:
      'Only one attachment per chat is allowed. If you want to upload more files, please create a new chat.'
  },
  apiKeys: {
    alerts: {
      failedCreate: 'The API key could not be created.',
      failedDelete: 'The API key could not be deleted.',
      deleteSuccess: 'The API key was deleted.',
      createSuccess: 'The API key was created.',
      info: 'Here you can generate API keys to be able to use the AI API (<a href="https://inference.ai.artcodix.cloud" target="_blank"><b>https://inference.ai.artcodix.cloud</b></a>) in your applications.'
    },
    createDialog: {
      title: 'Create API Key',
      description: 'Set a name and description for your API key'
    },
    deleteDialog: {
      title: 'Delete API Key',
      description: 'Are you sure you want to delete this API key?'
    },
    showAPIKeyDialog: {
      title: 'API Key',
      description:
        'Make sure to copy your personal access token now as you will not be able to see this again.'
    },
    noRows: 'No API keys available yet'
  }
};

export default en;
